import { render } from "./CalendarDemo.vue?vue&type=template&id=6b2be18b"
import script from "./CalendarDemo.vue?vue&type=script&lang=js"
export * from "./CalendarDemo.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__